import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const IsochroneVersioningRBAC = {
  pageID: 'b194ae25d4ffeab066e33129ea4e96bb',
  elementID: {
    ViewPage: 'dd273a3d318afb37fe97edf9cde6bf4d',
    ActivateVersion: 'e9151c22f3b2d5794f045ecfa370bb90',
    DeleteVersion: '968fa6ed1e28102004181401563cb326',
    LihatDetailVersion: 'c8edef2a1166a5ac7c1564cffcdacc32',
    CreateVersion: '0fb6338c21dfe84b519db718bef82609',
    DuplicateVersion: '91443efb862e7c784340030efb99dd9a',
  },
} as const

export const useIsochroneVersioningRBACPage = createUseRBAC(IsochroneVersioningRBAC.elementID)

export type UseIsochroneVersioningRBACPageType = ReturnType<typeof useIsochroneVersioningRBACPage>
